<template>
  <div class="hajj-search">
    <div class="hajj-search__container">
      <div class="hajj-search__header">
        <h2 class="hajj-search__title">Қажыларды іздеу</h2>
        <p class="hajj-search__subtitle">Аты жөніңізді, аймақты таңдап іздеу</p>
      </div>

      <div class="hajj-search__form">
        <div class="hajj-search__input-group">
          <input
            v-model="form.name"
            type="text"
            class="hajj-search__input"
            placeholder="Аты жөні"
          />
        </div>

        <div class="hajj-search__select-group">
          <div class="hajj-search__select-wrapper">
            <select v-model="form.region_id" class="hajj-search__select">
              <option :value="null">Аймақты таңдаңыз:</option>
              <option
                v-for="region in regions"
                :key="region.id"
                :value="region.id"
              >
                {{ region.name }}
              </option>
            </select>
            <svg-icon name="arrow-down" class="hajj-search__select-icon" />
          </div>
        </div>

        <div class="hajj-search__select-group">
          <div class="hajj-search__select-wrapper">
            <select v-model="form.hajj_date__year" class="hajj-search__select">
              <option :value="null">Қажылық жасаған жылы</option>
              <option v-for="year in years" :key="year" :value="year">
                {{ year }}
              </option>
            </select>
            <svg-icon name="arrow-down" class="hajj-search__select-icon" />
          </div>
        </div>

        <button @click="search" class="hajj-search__button">Іздеу</button>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import SvgIcon from "@/components/SvgIcon.vue";
import { geoService } from "@/services";

export default defineComponent({
  name: "HajjSearch",
  components: {
    SvgIcon,
  },
  data() {
    return {
      regions: [],
      form: {
        name: "",
        region_id: null,
        hajj_date__year: null,
      },
    };
  },
  computed: {
    years() {
      const currentYear = new Date().getFullYear();
      const years = [];
      for (let i = 2017; i <= currentYear; i++) {
        years.push(i);
      }
      return years.reverse();
    },
  },
  mounted() {
    this.getRegions();
  },
  methods: {
    getRegions() {
      geoService.getPilgrimRegions().then(({ results }) => {
        this.regions = results;
      });
    },
    search() {
      const query = {
        search: this.form.name || undefined,
        region_id: this.form.region_id || undefined,
        hajj_date__year: this.form.hajj_date__year || undefined,
      };
      this.$router.push({
        name: "hajis",
        query,
      });
    },
  },
});
</script>

<style scoped lang="scss">
.hajj-search {
  @apply bg-white rounded-[24px] p-6;

  &__container {
    @apply flex flex-col gap-4;
  }

  &__header {
    @apply flex flex-col gap-1;
  }

  &__title {
    @apply text-[20px] font-semibold text-[#222222];
  }

  &__subtitle {
    @apply text-[15px] text-[#888888];
  }

  &__form {
    @apply flex flex-col gap-6;
  }

  &__input-group {
    @apply w-full;
  }

  &__input {
    @apply w-full h-[53px] bg-[#F1F1F1] rounded-lg px-4 text-[15px] text-[#888888] placeholder:text-[#888888];
  }

  &__select-group {
    @apply flex flex-col gap-2;
  }

  &__select-label {
    @apply text-[15px] text-[#222222];
  }

  &__select-wrapper {
    @apply relative w-full;
  }

  &__select {
    @apply w-full h-[56px] bg-[#F1F1F1] rounded-lg px-4 text-[15px] text-[#222222] appearance-none pr-10;
  }

  &__select-icon {
    @apply absolute right-4 top-1/2 -translate-y-1/2 w-6 h-6 text-[#282F3E];
  }

  &__button {
    @apply w-[140px] h-[50px] bg-[#058242] rounded-2xl text-[15px] text-white font-medium;
  }
}
</style>
